import React from 'react';

import BranchesIcon from '@atlaskit/icon/glyph/bitbucket/branches';
import PullRequestsIcon from '@atlaskit/icon/glyph/bitbucket/pullrequests';

import TagIcon from './assets/TagIcon';

export type Props = {
  type: string;
};

const BuildRefIcon = ({ type }: Props) => {
  if (type === 'pull-requests') {
    return <PullRequestsIcon size="small" label="Pull Request" />;
  }

  if (type === 'branch' || type === 'named_branch') {
    return <BranchesIcon size="small" label="Branch" />;
  }

  if (type === 'tag' || type === 'annotated_tag' || type === 'bookmark') {
    return <TagIcon />;
  }

  return null;
};

export default React.memo(BuildRefIcon);
